import {ClientTermsAndConditionsTarget} from '~/openapi';

/**
 * SUBCONTRACTOR is being renamed AGENCY (CS2-1184). Documents can carry either name until every
 * deployed version writes the new one, so they are read as one and written as the older name.
 */
export const AGENCY_TARGET_TO_SEND = ClientTermsAndConditionsTarget.Subcontractor;

export function isAgencyTarget(target?: ClientTermsAndConditionsTarget): boolean {
    return target === ClientTermsAndConditionsTarget.Agency || target === ClientTermsAndConditionsTarget.Subcontractor;
}
